import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../styles/admin-theme.css';

const AdminMenu = ({ tabs }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className='admin-tabs bg-white'>
      {tabs.map(tab => {
        const isActive =
          tab.url === '/admin'
            ? currentPath === '/admin' || currentPath === '/admin/'
            : currentPath.startsWith(tab.url);

        return (
          <NavLink
            key={tab.id}
            to={tab.url}
            className={`admin-tab-link${isActive ? ' active' : ''}`}
          >
            {tab.label}
          </NavLink>
        );
      })}
    </nav>
  );
};

export default AdminMenu;
